<template>
    <div class="admin-login">
        <div class="login-container">
            <a-card class="login-card" :bordered="false">
                <div class="login-header">
                    <h1>MAHIRU 博客后台</h1>
                    <p>管理员登录</p>
                </div>

                <a-form :model="formData" @finish="login" layout="vertical" class="login-form">
                    <a-form-item label="邮箱" name="email" :rules="[
                        { required: true, message: '请输入邮箱' },
                        { type: 'email', message: '请输入有效的邮箱地址' }
                    ]">
                        <a-input v-model:value="formData.email" placeholder="请输入邮箱" size="large"
                            :disabled="isLoading" />
                    </a-form-item>

                    <a-form-item label="密码" name="password" :rules="[{ required: true, message: '请输入密码' }]">
                        <a-input-password v-model:value="formData.password" placeholder="请输入密码" size="large"
                            :disabled="isLoading" />
                    </a-form-item>

                    <a-form-item>
                        <a-button type="primary" html-type="submit" size="large" :loading="isLoading"
                            :disabled="!formData.email.trim() || !formData.password.trim()" block>
                            {{ isLoading ? '验证中...' : '登录' }}
                        </a-button>
                    </a-form-item>
                </a-form>

                <a-alert v-if="errorMessage" :message="errorMessage" type="error" show-icon class="error-alert" />
            </a-card>
        </div>
    </div>
</template>

<script>
import supabaseAuthService from '../../services/supabaseAuthService.js'

export default {
    name: 'AdminLogin',
    data() {
        return {
            formData: {
                email: '',
                password: ''
            },
            isLoading: false,
            errorMessage: ''
        }
    },
    async mounted() {
        const session = await supabaseAuthService.getSession()
        if (session) {
            const isAdmin = await supabaseAuthService.ensureAdmin()
            if (isAdmin) {
                this.$router.push('/admin/dashboard')
            }
        }
    },
    methods: {
        async login() {
            if (!this.formData.email.trim() || !this.formData.password.trim()) {
                this.errorMessage = '请输入邮箱和密码'
                return
            }

            this.isLoading = true
            this.errorMessage = ''

            try {
                await supabaseAuthService.signInWithPassword(
                    this.formData.email.trim(),
                    this.formData.password.trim()
                )
                const isAdmin = await supabaseAuthService.ensureAdmin()
                if (!isAdmin) {
                    this.errorMessage = '您没有管理员权限'
                    await supabaseAuthService.signOut()
                    return
                }
                this.$router.push('/admin/dashboard')
            } catch (error) {
                console.error('Login error:', error)
                this.errorMessage = this.getErrorMessage(error.message)
            } finally {
                this.isLoading = false
            }
        },

        getErrorMessage(message) {
            if (/Invalid login credentials/i.test(message)) {
                return '账号或密码错误'
            }
            return '登录失败，请检查网络或稍后重试'
        }
    }
}
</script>

<style scoped>
.admin-login {
    min-height: 100vh;
    background: #f0f2f5;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 24px;
}

.login-container {
    width: 100%;
    max-width: 400px;
}

.login-card {
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
}

.login-header {
    text-align: center;
    margin-bottom: 32px;
}

.login-header h1 {
    color: #1890ff;
    font-size: 28px;
    font-weight: 700;
    margin-bottom: 8px;
}

.login-header p {
    color: #666;
    font-size: 16px;
    margin: 0;
}

.error-alert {
    margin-top: 16px;
}

/* 使用默认主题色 */
</style>